export enum SvgImages {
  error401 = 'error-401.svg',
  error403 = 'error-403.svg',
  error404 = 'error-404.svg',
  error500 = 'error-500.svg',
  error503 = 'error-503.svg'
}

export enum Icons {}

export type IconNames =keyof typeof Icons;

export type SvgImageNames=keyof typeof SvgImages;
